import $ from "jquery";
export default class Snackbar {
    static show(message) {
        let $message = $('<div id="snackbar">' + message + '</div>');
        $('body').append($message);
        $message.addClass('show');
        setTimeout(function () {
            $message.removeClass('show');
            setTimeout(function () {
                $message.remove();
            }, 600);
        }, 3000);
    }
}
